/* eslint-disable promise/always-return */
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FC, useContext } from 'react'
import { useIntl } from 'react-intl'

import Swal from 'sweetalert2'
import { WizardButtonNext, WizardButtonPrev, WizardButtonsWrapper } from 'ufinet-web-components'
import { AuthContext, IAreaModal, kmzAreaService } from 'ufinet-web-functions'
import { AreaPreviewTable } from '../../common/preview/AreaPreviewTable'

type Props = {
	data: IAreaModal
	wizardRef: any
	actionButtonRef: any
	hideModal: Function
}
const AreaModConfirm: FC<Props> = ({ data, wizardRef, actionButtonRef, hideModal }: Props) => {
	const intl = useIntl()
	const authData = useContext(AuthContext)
	const _kmzAreaService = kmzAreaService(authData)

	const preConfirmKmz = (e: any) => {
		e.preventDefault()
		Swal.fire({
			title: intl.formatMessage({ id: 'STEP.CABLES&BOXES.LOAD_KMZ.SWEET_ALERT.TITLE' }),
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			reverseButtons: true,
			confirmButtonText: intl.formatMessage({ id: 'SAVE' }),
			cancelButtonText: intl.formatMessage({ id: 'CANCEL' }),
			showLoaderOnConfirm: true,
			preConfirm: () => {
				confirmKmz()
					.then(() => {
						Swal.fire({
							title: intl.formatMessage({ id: 'STEP.CABLES&BOXES.LOAD_KMZ.SWEET_ALERT.TITLE.SUCCESS' }),
							text: intl.formatMessage({ id: 'STEP.CABLES&BOXES.LOAD_KMZ.SWEET_ALERT.TEXT.SUCCESS' }),
							showConfirmButton: true,
							confirmButtonColor: '#0065A4',
							allowOutsideClick: false,
							icon: 'success',
							preConfirm: () => {
								hideModal()
							},
						})
					})
					.catch(() => {
						Swal.fire({
							title: 'Error',
							text: 'something goes wrong',
							showConfirmButton: true,
							confirmButtonColor: '#0065A4',
							allowOutsideClick: false,
							icon: 'error',
							preConfirm: () => {
								hideModal()
							},
						})
					})
			},
			confirmButtonColor: '#0065A4',
			cancelButtonColor: '#f64e60',
			allowOutsideClick: false,
		})
	}

	const confirmKmz = async () => {
		return await _kmzAreaService.confirmKmzToUpdateArea(data.id, { kmzStorageUrls: data.storageUrls || [''] })
	}

	return (
		<form onSubmit={preConfirmKmz} className="h-100 p-15 d-flex flex-column">
			<div className="alert alert-dismissible bg-light-warning d-flex flex-center flex-column py-10 px-10 px-lg-10 mb-10">
				<FontAwesomeIcon color="#F7BB49" size="4x" icon={faCircleExclamation} />
				<div className="text-center pt-2">
					<h1 className="fw-bolder mb-5">{intl.formatMessage({ id: 'ATTENTION' })}</h1>
					<div className="separator separator-dashed border-danger opacity-25 mb-5" />
					<div className="mb-9 text-dark">{intl.formatMessage({ id: 'STEP.CABLES&BOXES.LOAD_KMZ.TEXT' })}</div>
				</div>
			</div>
			<AreaPreviewTable data={data} />
			<WizardButtonsWrapper>
				<WizardButtonPrev wizardRef={wizardRef} />
				<WizardButtonNext wizardRef={wizardRef} actionButtonRef={actionButtonRef} submitForm />
			</WizardButtonsWrapper>
		</form>
	)
}
export { AreaModConfirm }
